@if(printerFormService.printerFormReady() && printer) {
    <form autocomplete="off" [formGroup]="printerGroupForm" class="tw-contents">
        <app-card 
            [fullWidth]="false"
            [withCard]="true"
            [cardTitle]="'PRINTERS.DETAIL.CATEGORIES' | translate"
        >
            <section class="tw-grid tw-grid-cols-1 tw-gap-x-4 tw-gap-y-3 tw-items-center tw-p-1"
                formGroupName="categoriesForm">
                <div class="tw-p-2">
                    <span [class]="subTitleClass">
                        {{'PRINTERS.DETAIL.ENABLE_CATEGORIES' | translate : {printer: printer} }}
                    </span>
                </div>
                <div class="tw-px-1">
                    <mat-checkbox [formControl]="printerFormService.allCategories" (change)="toggleAllCategories()"
                    >
                        <span class="break-words-auto">{{ 'PRINTERS.DETAIL.SELECT_ALL' | translate }}</span>
                    </mat-checkbox>
                    <!-- <mat-slide-toggle [formControl]="printerFormService.allCategories" (change)="toggleAllCategories()" class="tw-flex tw-p-3">
                        <span class="tw-flex tw-ml-2">{{ 'PRINTERS.DETAIL.SELECT_ALL' | translate }}</span>
                    </mat-slide-toggle> -->
                </div>

                <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-4 tw-px-1" 
                    formArrayName="categories">
                    @for(category of printerFormService.categoriesArray.controls; track i; let i = $index) {
                        <div [formGroupName]="i">
                            <!-- <mat-slide-toggle formControlName="checked" (change)="onSingleCategoryChange()" class="tw-flex tw-p-3">
                                <span class="tw-flex tw-ml-2">{{ category.get('name')?.value }}</span>
                            </mat-slide-toggle> -->
                            <mat-checkbox formControlName="checked" (change)="onSingleCategoryChange()">
                                <span class="tw-flex tw-ml-2">{{ category.get('name')?.value }}</span>
                            </mat-checkbox>
                        </div>
                    }
                </div>
    
            </section>
        </app-card>

        <div class="tw-flex tw-flex-col tw-gap-4 tw-h-full">
            <app-card
                [fullWidth]="false"
                [withCard]="true"
                [cardTitle]="'PRINTERS.DETAIL.ROOMS' | translate"
            >
                <section class="tw-grid tw-grid-cols-1 tw-gap-x-4 tw-gap-y-3 tw-items-center tw-p-1"
                    formGroupName="nonFiscalConfiguration">
                    <div class="tw-p-2">
                        <span [class]="subTitleClass">
                            {{'PRINTERS.DETAIL.LIMIT_ROOMS' | translate : {printer: printer} }}
                        </span>
                    </div>
                    <div class="tw-px-1">
                        <mat-checkbox [formControl]="printerFormService.allRooms" (change)="toggleAllRooms()">
                            <span class="break-words-auto">{{ 'PRINTERS.DETAIL.SELECT_ALL' | translate }}</span>
                        </mat-checkbox>

                        <!-- <mat-slide-toggle [formControl]="printerFormService.allRooms" (change)="toggleAllRooms()" class="tw-flex tw-p-3">
                            <span class="tw-flex tw-ml-2">{{ 'PRINTERS.DETAIL.SELECT_ALL' | translate }}</span>
                        </mat-slide-toggle> -->
                    </div>

                    <div class="tw-grid tw-grid-cols-1  md:tw-grid-cols-2 tw-gap-4 tw-px-1" 
                        formArrayName="rooms">
                        @for(room of printerFormService.roomsArray.controls; track i; let i = $index) {
                            <div [formGroupName]="i">
                                <!-- <mat-slide-toggle formControlName="checked" (change)="onSingleRoomChange()" class="tw-flex tw-p-3">
                                    <span class="tw-flex tw-ml-2">{{ room.get('name')?.value }}</span>
                                </mat-slide-toggle> -->
                                <mat-checkbox formControlName="checked" (change)="onSingleRoomChange()">
                                    <span class="break-words-auto">{{ room.get('name')?.value }}</span>
                                </mat-checkbox>
                            </div>
                        }
                    </div>
                </section>
            </app-card>

            <app-card
                [fullWidth]="false"
                [withCard]="true"
                [cardTitle]="'PRINTERS.DETAIL.CASHREGISTERS' | translate"
            >
                <section class="tw-grid tw-grid-cols-1 tw-gap-x-4 tw-gap-y-3 tw-items-center tw-p-1">
                    <div class="tw-flex tw-flex-col tw-gap-2">
                        <mat-slide-toggle [formControl]="printerFormService.fromCashregistersOnly!" class="tw-flex tw-p-3">
                            <span class="tw-flex tw-ml-2">{{ 'PRINTERS.DETAIL.CASHREGISTERS_ONLY' | translate}}</span>
                        </mat-slide-toggle>
                    </div>
                    <div class="tw-flex tw-flex-col tw-gap-y-3" formGroupName="nonFiscalConfiguration">
                        <div class="tw-p-2">
                            <span [class]="subTitleClass">
                                {{'PRINTERS.DETAIL.LIMIT_CASHREGISTERS' | translate : {printer: printer} }}
                            </span>
                        </div>
                        <div class="tw-px-1">
                            <!-- <mat-slide-toggle [formControl]="printerFormService.allCashregisters" (change)="toggleAllCashregisters()" class="tw-flex tw-p-3">
                                <span class="tw-flex tw-ml-2">{{ 'PRINTERS.DETAIL.SELECT_ALL' | translate }}</span>
                            </mat-slide-toggle> -->
                            <mat-checkbox [formControl]="printerFormService.allCashregisters" (change)="toggleAllCashregisters()">
                                <span class="break-words-auto">{{ 'PRINTERS.DETAIL.SELECT_ALL' | translate }}</span>
                            </mat-checkbox>
                        </div>
    
                        <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-4 tw-px-1" 
                            formArrayName="cashregisters">
                            @for(cash of printerFormService.cashregistersArray.controls; track i; let i = $index) {
                                <div [formGroupName]="i">
                                    <!-- <mat-slide-toggle formControlName="checked" (change)="onSingleCashregisterChange()" class="tw-flex tw-p-3">
                                        <span class="tw-flex tw-ml-2">{{ cash.get('name')?.value }}</span>
                                    </mat-slide-toggle> -->
                                    <mat-checkbox formControlName="checked" (change)="onSingleCashregisterChange()">
                                        <span class="break-words-auto">{{ cash.get('name')?.value }}</span> 
                                    </mat-checkbox>
                                </div>
                            }
                        </div>
                    </div>
                </section>
            </app-card>
        </div>

        <app-card
            [fullWidth]="false"
            [withCard]="true"
            [cardTitle]="'PRINTERS.DETAIL.OTHER_PRINTERS' | translate"
        >
            <section class="tw-grid tw-grid-cols-1 tw-gap-x-4 tw-gap-y-3 tw-items-center tw-p-1"
                formGroupName="nonFiscalConfiguration">
                <div class="tw-p-2">
                    <span [class]="subTitleClass">
                        {{'PRINTERS.DETAIL.PRINT_OTHER_PRINTERS_CONTENT' | translate : {printer: printer} }}
                    </span>
                </div>
                <div class="tw-px-1">
                    <!-- <mat-slide-toggle [formControl]="printerFormService.allOtherPrinters" (change)="toggleAllOtherPrinters()" class="tw-flex tw-p-3">
                        <span class="tw-flex tw-ml-2">{{ 'PRINTERS.DETAIL.SELECT_ALL' | translate }}</span>
                    </mat-slide-toggle> -->
                    <mat-checkbox [formControl]="printerFormService.allOtherPrinters" (change)="toggleAllOtherPrinters()">
                        <span class="break-words-auto">{{ 'PRINTERS.DETAIL.SELECT_ALL' | translate }}</span>
                    </mat-checkbox>
                </div>

                <div class="tw-grid tw-grid-cols-1 tw-gap-4 tw-px-1" 
                    formArrayName="otherPrinters">
                    @for(print of printerFormService.otherPrintersArray.controls; track i; let i = $index) {
                        <div [formGroupName]="i" class="tw-border-0 tw-border-b tw-border-solid tw-border-[var(--sys-divider)] 
                                    min-[1025px]:tw-border-0 max-[1025px]:tw-pb-4 last:tw-border-0 first:tw-pt-0 md:tw-pt-0">
                            <section class="tw-grid tw-grid-cols-1 md:tw-grid-cols-12">
                                <div class="tw-col-span-12 min-[1025px]:tw-col-span-4">
                                    <!-- <mat-slide-toggle formControlName="checked" (change)="onSinglePrinterChange(i)" class="tw-flex tw-p-3">
                                        <span class="tw-flex tw-ml-2">{{ print.get('name')?.value }}</span>
                                    </mat-slide-toggle> -->
                                    <mat-checkbox formControlName="checked" (change)="onSinglePrinterChange(i)">
                                        <span class="break-words-auto">{{ print.get('name')?.value }}</span>
                                    </mat-checkbox>
                                </div>
                                <div class="tw-col-span-12 min-[1025px]:tw-col-span-8">
                                    <!-- <mat-slide-toggle formControlName="inline" class="tw-flex tw-p-3">
                                        <span class="tw-flex tw-ml-2">{{ "PRINTERS.DETAIL.PRINT_OTHER_PRINTERS_CONTENT_INLINE" | translate }}</span>
                                    </mat-slide-toggle> -->
                                    <mat-checkbox formControlName="inline" [disabled]="!print.get('checked')?.value">
                                        <span class="break-words-auto">{{ "PRINTERS.DETAIL.PRINT_OTHER_PRINTERS_CONTENT_INLINE" | translate }}</span>
                                    </mat-checkbox>
                                </div>
                            </section>
                        </div>
                    }
                </div>
            </section>
        </app-card>

        <app-card
            [fullWidth]="false"
            [withCard]="true"
            [cardTitle]="'PRINTERS.DETAIL.ITEMS' | translate"
        >
            <section class="tw-grid tw-grid-cols-1 tw-gap-x-4 tw-gap-y-3 tw-items-center tw-p-1"
                formGroupName="nonFiscalConfiguration">
                <div class="tw-p-2">
                    <span [class]="subTitleClass">
                        <span class="break-words-auto">{{'PRINTERS.DETAIL.ITEMS_SECTION' | translate : {printer: printer} }}</span>
                    </span>
                </div>

                <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-4 tw-px-1" 
                    formArrayName="items">
                    @for(item of printerFormService.itemsArray.controls; track i; let i = $index) {
                        <div [formGroupName]="i">
                            <!-- <mat-slide-toggle formControlName="checked" 
                            class="tw-flex tw-p-3">
                                <span class="tw-flex tw-ml-2">{{ item.get('name')?.value }}</span>
                            </mat-slide-toggle> -->
                            <mat-checkbox formControlName="checked" [disabled]="true">
                                <span class="break-words-auto">{{ item.get('name')?.value }}</span>
                            </mat-checkbox>
                        </div>
                    }
                </div>
            </section>
        </app-card>
    </form>
}